export const safely =
  <T extends unknown[], R>(
    fn: (...args: T) => R,
    catchHandler = (error: unknown) => console.error(error)
  ) =>
  (...args: T): R | ReturnType<typeof catchHandler> => {
    try {
      const result = fn(...args);

      if (result instanceof Promise) {
        return result.catch(catchHandler) as R;
      }

      return result;
    } catch (error) {
      return catchHandler(error);
    }
  };
